import { useQuery } from '@tanstack/react-query';

import { useApi } from 'services/api';
import type { Milliseconds } from 'types/time';
import type { components } from 'types/schemas/api-schema';

type Params = {
  alternateId: string | null | undefined;
  sensorId: number | string | null | undefined;
  alertTs: Milliseconds;
  enabled?: boolean;
};

type OktaActorIdResponse = components['schemas']['OktaActorIdResult'] | null;

const HOUR_MS = 60 * 60 * 1000;

const useGetOktaActorIdByAlternateId = ({ alternateId, sensorId, alertTs, enabled = true }: Params) => {
  const api = useApi();
  const isEnabled = Boolean(enabled && alternateId && sensorId != null && alertTs);

  return useQuery<OktaActorIdResponse>({
    queryKey: ['okta-actor-id', sensorId, alternateId, alertTs],
    queryFn: async ({ signal }) => {
      const start = new Date(alertTs - HOUR_MS).toISOString();
      const end = new Date(alertTs + HOUR_MS).toISOString();
      return (await api.get('/search/okta-actor-id', {
        params: { alternateId, sensorId, start, end },
        signal,
      })) as OktaActorIdResponse;
    },
    enabled: isEnabled,
    staleTime: 5 * 60 * 1000,
    gcTime: 15 * 60 * 1000,
    retry: false,
  });
};

export default useGetOktaActorIdByAlternateId;
